import React from 'react';
import { Clock } from 'lucide-react';

export const DurationSelector = ({ duration, onDurationChange }) => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4 text-purple-400">
        <Clock className="w-5 h-5" />
        <h2 className="font-semibold">Duration</h2>
      </div>
      <div className=" backdrop-blur-xl rounded-2xl p-6 ">
        <div className="flex w-[80%] gap-4">
          {[2, 5, 10].map((mins) => (
            <button
              key={mins}
              onClick={() => onDurationChange(mins.toString())}
              className={`flex-1 p-4 rounded-xl transition-all ${
                duration === mins.toString()
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500'
                  : 'bg-gray-900/50 hover:bg-gray-700/50'
              }`}
            >
              <div className="text-center">
                <span className="text-2xl font-bold">{mins}</span>
                <span className="text-sm ml-1">min</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};